import React, {useState} from 'react';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Checkbox} from "primereact/checkbox";
import {AppContext} from "../../HomePage";

// Field definitions per integration namespace in user.api_integration.
// Field names must match the stored credential keys exactly.
export const INTEGRATIONS = [
    {key: 'hepsiburada', summaryField: 'merchant_id', fields: [
        {name: 'merchant_id', label: 'user.api.merchant_id'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'merchant_name', label: 'user.api.merchant_name'},
        {name: 'test_environment', label: 'user.api.test_environment', type: 'boolean'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'trendyol', summaryField: 'merchant_id', fields: [
        {name: 'merchant_id', label: 'user.api.merchant_id'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'merchant_name', label: 'user.api.merchant_name'}
    ]},
    {key: 'idefix', summaryField: 'vendorId', fields: [
        {name: 'vendorId', label: 'user.api.vendorId'},
        {name: 'token', label: 'user.api.token'},
        {name: 'secret', label: 'user.api.secret'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'tsoft', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'ticimax', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'uye_kodu', label: 'user.api.uye_kodu'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'entegra', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'coddepo', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'ideasoft', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'ikas', summaryField: 'store_name', fields: [
        {name: 'store_name', label: 'user.api.ikas_store_name'},
        {name: 'domain', label: 'user.api.ikas_domain'},
        {name: 'client_id', label: 'user.api.client_id'},
        {name: 'client_secret', label: 'user.api.client_secret'}
    ]},
    {key: 'nebim', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.nebim_url'},
        {name: 'server_name', label: 'user.api.nebim_server_name'},
        {name: 'database_name', label: 'user.api.nebim_database_name'},
        {name: 'user_group_code', label: 'user.api.nebim_user_group_code'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'price_group_code', label: 'user.api.nebim_price_group_code'},
        {name: 'domain', label: 'user.api.ikas_domain'}
    ]},
    {key: 'shopify', summaryField: 'store_name', fields: [
        {name: 'store_name', label: 'user.api.store_name'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'api_version', label: 'user.api.api_version'}
    ]},
    {key: 'woocommerce', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'api_version', label: 'user.api.api_version'},
        {name: 'price_code_map', label: 'user.api.price_code_map', textarea: true}
    ]},
    {key: 'aaro', summaryField: 'username', fields: [
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'enarhome', summaryField: 'username', fields: [
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'capsule', summaryField: 'username', fields: [
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'ecza1', summaryField: 'username', fields: [
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'farmazon', summaryField: 'username', fields: [
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'maropost', summaryField: 'url', fields: [
        {name: 'url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'}
    ]},
    {key: 'dia', summaryField: 'ws_url', fields: [
        {name: 'ws_url', label: 'user.api.url'},
        {name: 'username', label: 'user.api.user_name'},
        {name: 'password', label: 'user.api.password'},
        {name: 'apikey', label: 'user.api.apikey'},
        {name: 'firma_kodu', label: 'user.api.firma_kodu'},
        {name: 'donem_kodu', label: 'user.api.donem_kodu'}
    ]}
];

const isObjectValue = (value) => value !== null && typeof value === 'object';

// Objects (e.g. price_code_map) would render as "[object Object]" in a text
// control and be corrupted on save; show them as pretty JSON instead. Booleans
// and primitives pass through untouched (so a checkbox still sees a real bool).
const toDisplayValues = (stored) => {
    const out = {};
    Object.keys(stored || {}).forEach(name => {
        out[name] = isObjectValue(stored[name]) ? JSON.stringify(stored[name], null, 2) : stored[name];
    });
    return out;
};

// Render the integration's declared fields PLUS any other keys actually stored
// on the user, so nothing entered elsewhere (e.g. a field added to the backend
// later, like merchant_name/test_environment) is silently hidden from the
// admin. Generic extras are labeled by their raw key.
const fieldsToRender = (integration, stored) => {
    const declaredNames = new Set(integration.fields.map(f => f.name));
    const extras = Object.keys(stored || {})
        .filter(name => !declaredNames.has(name))
        .map(name => ({name, generic: true}));
    return [...integration.fields, ...extras];
};

const UserIntegrations = ({user, onPersist}) => {

    const {t} = React.useContext(AppContext);
    const [expandedKey, setExpandedKey] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [editValues, setEditValues] = useState({});
    const [saving, setSaving] = useState(false);

    const isConnected = (integration) => user.api_integration && user.api_integration[integration.key];
    const byDisplayName = (a, b) => t('user.api.' + a.key).localeCompare(t('user.api.' + b.key), undefined, {sensitivity: 'base'});
    const connected = INTEGRATIONS.filter(isConnected).sort(byDisplayName);
    const available = INTEGRATIONS.filter(integration => !isConnected(integration))
        .sort(byDisplayName)
        .map(integration => ({label: t('user.api.' + integration.key), value: integration.key}));

    const collapse = () => {
        setExpandedKey(null);
        setIsNew(false);
        setEditValues({});
    };

    const openIntegration = (key) => {
        setExpandedKey(key);
        setIsNew(false);
        setEditValues(toDisplayValues(user.api_integration[key]));
    };

    const addIntegration = (key) => {
        const integration = INTEGRATIONS.find(i => i.key === key);
        const emptyValues = {};
        integration.fields.forEach(field => emptyValues[field.name] = field.type === 'boolean' ? false : '');
        setExpandedKey(key);
        setIsNew(true);
        setEditValues(emptyValues);
    };

    const saveExpanded = () => {
        const stored = (user.api_integration && user.api_integration[expandedKey]) || {};
        // Re-parse fields that were originally JSON objects (shown as text) so we
        // persist the object, not its stringified form. A malformed edit is left
        // as-is rather than silently dropped -- the backend save surfaces it.
        const persisted = {...editValues};
        Object.keys(persisted).forEach(name => {
            if (isObjectValue(stored[name]) && typeof persisted[name] === 'string') {
                try { persisted[name] = JSON.parse(persisted[name]); } catch (e) { /* keep raw string */ }
            }
        });
        const updatedUser = {...user, api_integration: {...(user.api_integration || {}), [expandedKey]: persisted}};
        setSaving(true);
        onPersist(updatedUser).then(collapse).catch(() => {}).finally(() => setSaving(false));
    };

    const removeIntegration = (key) => {
        if (!window.confirm(t('user.api.remove_confirm')))
            return;
        const api_integration = {...(user.api_integration || {})};
        delete api_integration[key];
        setSaving(true);
        onPersist({...user, api_integration}).then(() => {
            if (expandedKey === key)
                collapse();
        }).catch(() => {}).finally(() => setSaving(false));
    };

    const renderField = (integration, field, stored) => {
        const id = `${integration.key}_${field.name}`;
        const original = stored ? stored[field.name] : undefined;
        const label = field.label ? t(field.label) : field.name;
        const setValue = (value) => setEditValues({...editValues, [field.name]: value});
        // Booleans (e.g. test_environment) render as a checkbox so they persist as
        // real booleans -- typing "false" into a text field would read as truthy.
        if (field.type === 'boolean' || typeof original === 'boolean') {
            return <div key={field.name} className="integration-form-check"
                        style={{display: 'flex', alignItems: 'center', gap: 8, margin: '6px 0'}}>
                <Checkbox inputId={id} checked={!!editValues[field.name]} onChange={(e) => setValue(e.checked)}/>
                <label htmlFor={id} style={{margin: 0}}>{label}</label>
            </div>;
        }
        const asTextarea = field.textarea || isObjectValue(original);
        return <span key={field.name} className="p-float-label">
            {asTextarea
                ? <InputTextarea id={id} value={editValues[field.name] || ''} rows={5} autoComplete="off"
                                 onChange={(e) => setValue(e.target.value)}/>
                : <InputText id={id} value={editValues[field.name] || ''} autoComplete="off"
                             onChange={(e) => setValue(e.target.value)}/>}
            <label htmlFor={id}>{label}</label>
        </span>;
    };

    const integrationForm = (integration) => {
        const stored = (!isNew && user.api_integration && user.api_integration[integration.key]) || {};
        return <div className="integration-form p-fluid">
            {fieldsToRender(integration, stored).map(field => renderField(integration, field, stored))}
            <div className="integration-form-actions">
                <Button label={t('actions.cancel')} className="p-button-text p-button-plain" onClick={collapse}/>
                <Button label={t('actions.save')} icon="pi pi-save" className="p-button-success" disabled={saving} onClick={saveExpanded}/>
            </div>
        </div>;
    };

    const shopifyAppShop = user.settings && user.settings.shopify_app && user.settings.shopify_app.shop;
    const newIntegration = isNew && expandedKey ? INTEGRATIONS.find(i => i.key === expandedKey) : null;

    return <div className="integrations">
        {shopifyAppShop &&
        <div className="integration-row readonly">
            <div className="integration-info">
                <span className="integration-name">{t('user.api.shopify_app')}</span>
                <a className="integration-summary" href={`https://${shopifyAppShop}/admin`} target="_blank" rel="noopener noreferrer"
                   onClick={(e) => e.stopPropagation()}>{shopifyAppShop}</a>
            </div>
            <span className="integration-badge">OAuth</span>
        </div>}

        {connected.map(integration => {
            const values = user.api_integration[integration.key];
            const isOpen = !isNew && expandedKey === integration.key;
            return <React.Fragment key={integration.key}>
                <div className={`integration-row${isOpen ? ' open' : ''}`}
                     onClick={() => isOpen ? collapse() : openIntegration(integration.key)}>
                    <div className="integration-info">
                        <span className="integration-name">{t('user.api.' + integration.key)}</span>
                        <span className="integration-summary">{values[integration.summaryField]}</span>
                    </div>
                    <div className="integration-actions">
                        <Button icon={isOpen ? 'pi pi-chevron-up' : 'pi pi-pencil'} className="p-button-text p-button-plain p-button-rounded"
                                tooltip={t('actions.edit')} onClick={(e) => {e.stopPropagation(); isOpen ? collapse() : openIntegration(integration.key);}}/>
                        <Button icon="pi pi-trash" className="p-button-text p-button-plain p-button-rounded"
                                tooltip={t('actions.delete')} disabled={saving} onClick={(e) => {e.stopPropagation(); removeIntegration(integration.key);}}/>
                    </div>
                </div>
                {isOpen && integrationForm(integration)}
            </React.Fragment>;
        })}

        {connected.length === 0 && !shopifyAppShop && !newIntegration &&
        <p className="integration-empty">{t('user.api.no_integrations')}</p>}

        {newIntegration &&
        <React.Fragment>
            <div className="integration-row open">
                <div className="integration-info">
                    <span className="integration-name">{t('user.api.' + newIntegration.key)}</span>
                </div>
            </div>
            {integrationForm(newIntegration)}
        </React.Fragment>}

        <div className="integration-add">
            <Dropdown value={null} options={available} placeholder={t('user.api.add_integration')}
                      filter={true} onChange={(e) => addIntegration(e.value)}/>
        </div>
    </div>;
};

export default UserIntegrations;
